<template>
  <div>
    <horizontal-stepper-pad
      :steps="steps"
      :oggetto="oggetto"
      @active-step="isStepActive"
      @completed-step="completeStep"
      @stepper-finished="endedStepper"
      @closemodal="$emit('closemodal')"
    >
    </horizontal-stepper-pad>
  </div>
</template>

<script>
import HorizontalStepperPad from '../customComponents/HorizontalStepperPad';
import SalvaRicercaRiepilogo from './SalvaRicercaRiepilogo';
import SalvaRicercaTelefono from './SalvaRicercaTelefono';

export default {
  name: 'SalvaRicercaWizard',
  components: {
    HorizontalStepperPad
  },

  props: {
    ricerca: {
      type: Object | Array,
      required: true
    },
    titolo: {
      type: String,
      default: 'Salva la tua ricerca per rimanere aggiornato'
    },
    sottoTitolo: {
      type: String,
      default: 'Ricevi via mail ogni giorno nuove proposte in linea con le tue richieste.'
    },
    source: {
      type: String,
    }
  },

  data () {
    return {
      steps: [
        { // Riepilogo
          icon: 'search',
          name: 'salva_ricerca_riepilogo',
          title: 'LA TUA RICERCA',
          content: {
            title: this.titolo,
            subtitle: this.sottoTitolo
          },
          component: SalvaRicercaRiepilogo,
          completed: false,
        },
        { // Step dettagli telefono e privacy
          icon: 'contact_phone',
          name: 'salva_ricerca_telefono_privacy',
          title: 'AGENZIE E IMPRESE',
          component: SalvaRicercaTelefono,
          completed: false,
        }
      ],
      oggetto: {
        ricerca: {
          name: null,
          note: null,
          contatto_telefonico: null,
          payload: this.ricerca
        },
        utente: {
          nome: null,
          cognome: null,
          telefono: null,
          email: null,
          privacy: null,
        },
        source: this.source,
      }
    }
  },

  methods: {
    // Executed when @completed-step event is triggered
    completeStep (payload) {
      this.steps.forEach((step) => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      })
    },

    // Executed when @active-step event is triggered
    isStepActive (payload) {
      this.steps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      })
    },

    /**
     * Executed when @stepper-finished event is triggered
     * @param payload
     * @param b
     */
    endedStepper (step_number, last_step_wizard) {
      // preparo la richiesta axios
      window.axios
        .post(process.env.MIX_BASE_URL + 'searches/my-search', { ...this.oggetto, last_step_wizard })
        .then(res => {
          Swal.fire({
            text: res.data.data.message,
            type: 'success'
          }).then(() => {
            if (last_step_wizard) {
              this.$emit('closemodal');
            }
          })
        })
        .catch(error => {
          let myError = error.response.data.data.error;
          switch (error.response.status) {
            case 401:
            case 422:
              Swal.fire({
                title: 'Attenzione!',
                text: myError,
                type: 'info'
              });
              break;

            default:
              Swal.fire({
                title: 'Oopss!',
                text: 'Problemi nel caricamento dati',
                type: 'error'
              });
              break;
          }
        })
    },
  },

  mounted () {
    // se l'utente è logato aggiungo i dati utente all'oggetto
    if (this.isLoggedIn) {
      this.$set(this.oggetto['utente'], 'nome', this.$root.user.nome);
      this.$set(this.oggetto['utente'], 'cognome', this.$root.user.cognome);
      this.$set(this.oggetto['utente'], 'email', this.$root.user.email);
    }
  },

  computed: {
    isLoggedIn () {
      return this.$root.user.id !== null
    },
  }
}
</script>

<style
  lang="scss"
  scoped
>
.segnala-modal {
  padding: 20px !important;
}

.stepper-box .bottom {
  border-top: none !important;
}

.stepper-box {
  box-shadow: none !important;
}

.stepper-button .next {
  background-color: var(--primary) !important;
}

.step .circle i {
  background-color: var(--primary) !important;
}

.stepper-button-top:not(.deactivated) {
  i {
    color: white !important;
  }

  background-color: var(--primary) !important;
  color: white !important;
  border-color: white !important;
}

.stepper-button-top .deactivated {
  background-color: grey !important;
}

h3 {
  margin: 0 0 10px 10px;
  font-size: 15px;
  font-weight: 700;
  text-align: left;
  letter-spacing: normal;
  color: var(--primary);
}

.stepper-box .content {
  margin-top: 3rem !important;
  margin-bottom: 1rem !important;
  min-height: 430px;
}
</style>